import { useState } from 'react';
import { ApiError } from './api.js';
// The mutation counterpart to useResource: wraps the repeated form-submit
// boilerplate — `setSaving(true)` / try-catch / `ApiError` → message /
// `setSaving(false)` — so forms just describe the call and react to success.
// Pair `error` with <FormError>{error}</FormError> and `saving` with the submit
// button's disabled state. The action closes over the latest render's state, so
// inline `useMutation(async () => api.post('/x', { ...form }))` sees current form
// values (React event handlers run the latest closures).
export function useMutation(action, opts) {
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);
    async function mutate(...args) {
        setError(null);
        setSaving(true);
        try {
            return await action(...args);
        }
        catch (e) {
            setError(e instanceof ApiError ? e.message : (opts?.fallbackError ?? 'Something went wrong'));
            return undefined;
        }
        finally {
            setSaving(false);
        }
    }
    return { mutate, saving, error, reset: () => setError(null) };
}
